import { useDesignMaxTheme } from "@/packages";
import { usePensionNameValue } from "@/shared/client";
import { type SpecialDmaxInfoResponse } from "@/shared/server";
import { FONT } from "@/styles";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import { SpecialPreviewCard } from "../preViewCard";

export const SpecialPreview = ({ special }: { special: SpecialDmaxInfoResponse }) => {
    const pensionName = usePensionNameValue();
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile, isLaptop } = MEDIAS();
    const { specials } = { ...special };
    const shuffled = [...specials].sort(() => Math.random() - 0.5).slice(0, 3);

    return (
        <Center position="relative" width="100%">
            <Center position="relative" as="section">
                <Flex
                    zIndex="1"
                    position="relative"
                    p="0 20px"
                    flexDir="column"
                    // eslint-disable-next-line no-nested-ternary
                    gap={isMobile ? "48px" : isLaptop ? "64px" : "96px"}
                >
                    <Flex gap="40px">
                        {!isMobile && <Box w="2px" bg="#6b6b6b" />}

                        <Box>
                            <Text
                                // eslint-disable-next-line no-nested-ternary
                                {...FONT("cormorant", isMobile ? 32 : isLaptop ? 48 : 56, 700, 1.2)}
                            >
                                SPECIAL
                            </Text>
                            <Text
                                mt={isMobile ? "16PX" : "24PX"}
                                // eslint-disable-next-line no-nested-ternary
                                {...FONT("pretendard", isMobile ? 12 : isLaptop ? 16 : 18, 300, 1.4)}
                            >
                                {pensionName.kor}의 특별함
                            </Text>
                        </Box>
                    </Flex>
                    <Flex w="100%" gap={isMobile ? "24PX" : "32px"} flexDir={isMobile ? "column" : "row"}>
                        {shuffled.map((special, index) => (
                            <SpecialPreviewCard
                                key={special.special_idx}
                                specialData={special}
                                direction={
                                    // eslint-disable-next-line no-nested-ternary
                                    isMobile ? "start" : index % 3 === 0 ? "start" : index % 3 === 1 ? "reverse" : "end"
                                }
                            />
                        ))}
                    </Flex>
                </Flex>
                {!isMobile && (
                    <Box zIndex="0" position="absolute" w="1611px" h="373px" bg="#3b6c8d" right="0" bottom="396px" />
                )}
            </Center>
        </Center>
    );
};
